import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\User\UsersImportController::__invoke
* @see app/Http/Controllers/User/UsersImportController.php
* @route '/api/user/users-import'
*/
const UsersImportController = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: UsersImportController.url(options),
    method: 'post',
})

UsersImportController.definition = {
    methods: ["post"],
    url: '/api/user/users-import',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\User\UsersImportController::__invoke
* @see app/Http/Controllers/User/UsersImportController.php
* @route '/api/user/users-import'
*/
UsersImportController.url = (options?: RouteQueryOptions) => {
    return UsersImportController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\User\UsersImportController::__invoke
* @see app/Http/Controllers/User/UsersImportController.php
* @route '/api/user/users-import'
*/
UsersImportController.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: UsersImportController.url(options),
    method: 'post',
})

export default UsersImportController